import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialState from './state';
import { TMeetingShare } from '@/common/basis/types/tmeeting-share';

const slice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    setMeetingShareData: (state, action: PayloadAction<TMeetingShare.Data>) => {
      state.meetingShareData = action.payload;
    },
  },
});

export const { setMeetingShareData } = slice.actions;

export default slice.reducer;
